import { createStore } from 'redux'

const initialState = {
  sidebarShow: (localStorage.getItem('sidebarShow') == undefined ?('responsive'):(localStorage.getItem('sidebarShow'))),
  //org_code : '3730102',
  org_code : (localStorage.getItem('org_code') == undefined ?('6710403'):(localStorage.getItem('org_code'))),
  role : 'survey',
  //annual : '2564'
  annual : (localStorage.getItem('annual') == undefined ?('2564'):(localStorage.getItem('annual'))),
  link : (localStorage.getItem('link') == undefined ?(''):(localStorage.getItem('link'))),
  genroute:false
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store